import React, { useState, useEffect } from "react";

import Layout from "../../components/layouts/Layout";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/forms-fields/Input";
import SelectBox from "../../components/forms-fields/SelectBox";
import {
  getRecords,
  isSuccess,
  catchAsync,
  isFail,
  formateDate,
  updateRecords,
  deleteRecords,
  toastSuccessMessages,
  toastErrorMessages,
  apiQuery,
  postRecords,
  handleRedirectIfProfileNotPresent
} from "../../helper/helper";
import {
  ADMIN_ID, BASE_URL, ADMIN_AUTH_TOKEN, UPLOAD_CONSENT_TEMPLATE_FILE,
  POST_CONSENT_TEMPLATE_URL,
  POST_SERVICE_USER_ENQUIRY_URL,
} from "../../env";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import { addConsentTemplate } from "../../schemas";
import TextArea from "../../components/forms-fields/TextArea";
import moment from "moment";

function CCAddNewForm() {
  // Getting user detail data
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);

  const [uploadedFilePath, setUploadedFilePath] = useState("");
  const [fileSizeError, setFileSizeError] = useState(false)

  const navigate = useNavigate();

  useEffect(() => {
    handleRedirectIfProfileNotPresent('profileUserDetails', '/service-users', navigate)
  }, [navigate]);

  // console.log("🚀 ~ file: CCAddNewForm.jsx:10 ~ CCAddNewForm ~ userDetails:", userDetails);
  const [disabledStatus, setDisableStatus] = useState(true);
  const [isToast, setIsToast] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

  const suSexOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  const [formData, setFormData] = useState({
    staffId: userDetails?.modelId?._id,
    description: "",
    attachment: uploadedFilePath
  });

  const handleFormSubmit = async (values) => {
    setIsSubmitButtonClicked(true);
    try {
      const updateValues = {

        ...values,
        attachment: uploadedFilePath,
        addedBy: ADMIN_ID,
      }
      const result = await postRecords(POST_CONSENT_TEMPLATE_URL, updateValues);

      if (result?.status === isSuccess) {
        setIsSubmitButtonClicked(false);
        toastSuccessMessages(
          toast?.success,
          result?.message,
          "/consent-capacity",
          1000,
          1000
        );
      } else if (result?.status === isFail) {
        setIsSubmitButtonClicked(false);
        toastErrorMessages(toast.error, result?.message, 1000);
      }
    } catch (error) {
      // Handle error
    }
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: formData,
      validationSchema: addConsentTemplate,
      onSubmit: handleFormSubmit, // Use the custom form submission handler
    });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...formData };
    let trimmedValue = value.trim();

    updatedData = {
      ...updatedData,
      [name]: trimmedValue,
    };

    setFormData(updatedData);

    handleChange(e);
    handleBlur(e);
    // console.log(updatedData);
  };


  //File Attachment
  const handleImageChange = async (e) => {
    setIsSubmitButtonClicked(true);

    try {
      const file = e.target.files[0];
      if (!file) {
        setIsSubmitButtonClicked(false);
        return;
      }

      const fileType = file.type; // application/pdf
      const fileSize = file.size;

      // Max size: 5MB
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setFileSizeError(true);
        setIsSubmitButtonClicked(false);
        return;
      }

      // ✅ Allow ONLY PDF
      if (fileType !== 'application/pdf') {
        alert('Only PDF files are allowed');
        setIsSubmitButtonClicked(false);
        return;
      }

      const fileData = new FormData();
      fileData.append('file', file);

      const apiResponse = await fetch(UPLOAD_CONSENT_TEMPLATE_FILE, {
        method: "POST",
        body: fileData,
        headers: {
          Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
        },
      });

      const resultResponse = await apiResponse.json();
      setUploadedFilePath(resultResponse?.data);

    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setIsSubmitButtonClicked(false);
    }
  };

  return (
    <>
      <Layout
        pageTitleText={
          <>
            Consent & Capacity <small>Add New Form</small>
          </>
        }
      >
        <div className="incidents consentCapacityAddNew">
          <form onSubmit={handleSubmit}>
            <div className="mainContent ">
              <div className="mainContentText">
                <h3>Consent & Capacity</h3>
                <div className="formBlockContent">
                  <div className="row">
                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="text"
                        id="suFirstMiddleName"
                        name="suFirstMiddleName"
                        value={userDetails?.modelId?.suFirstMiddleName}
                        labelText="First Name"
                        disabledStatus={disabledStatus}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="text"
                        id="suLastName"
                        name="suLastName"
                        value={userDetails?.modelId?.suLastName}
                        labelText="Last Name"
                        disabledStatus={disabledStatus}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="text"
                        id="suMobileHomeNo"
                        name="suMobileHomeNo"
                        value={userDetails?.modelId?.suMobileHomeNo}
                        labelText="Mobile Home No."
                        disabledStatus={disabledStatus}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="text"
                        id="suEmailHome"
                        name="suEmailHome"
                        value={userDetails?.modelId?.suEmailHome}
                        labelText="Email"
                        disabledStatus={disabledStatus}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <SelectBox
                        name="suSex"
                        id="suSex"
                        options={suSexOptions}
                        defaultValue={userDetails?.modelId?.suSex}
                        labelText={userDetails?.modelId?.suSex}
                        disabled={disabledStatus}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <div className="multipleFieldsBox">
                        <div className="div70">
                          <Input
                            type="text"
                            id="suDOB"
                            name="suDOB"
                            value={moment(userDetails?.modelId?.suDOB).format("DD/MM/YYYY")}
                            labelText="DOB"
                            disabledStatus={disabledStatus}
                          />
                        </div>
                        <div className="div30">
                          <Input
                            type="text"
                            id="suAge"
                            name="suAge"
                            value={userDetails?.modelId?.suAge}
                            // onChange={handleInputChange}
                            // onBlur={handleBlur}
                            labelText="Age"
                            disabledStatus={disabledStatus}
                          // customError={
                          //   errors.suFirstMiddleName && touched.suFirstMiddleName
                          // }
                          // errorMessage={errors.suFirstMiddleName}
                          // erroClass={
                          //   errors.suFirstMiddleName && touched.suFirstMiddleName
                          // }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      {/* <div className="memoryBoxContent">
                        <div className="imageBox text-center">
                          <label htmlFor="profilePicture" className="upload-icon">
                            <div className="avatarAction">
                              {uploadedFilePath !== '' && (
                                <>
                                  {uploadedFilePath.match(/\.(jpeg|jpg|png)$/i) ? (
                                    <img
                                      src={`${BASE_URL}${uploadedFilePath}`}
                                      alt="Memory Box"
                                      style={{ cursor: "pointer" }}
                                    />
                                  ) : (
                                    <video
                                      controls
                                      src={`${BASE_URL}${uploadedFilePath}`}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                                </>
                              )}
                            </div>
                          </label>
                        </div>
                      </div> */}
                      <div className="form-group">
                        <input
                          name="fileName"
                          id="fileName"
                          type="file"
                          accept="application/pdf"
                          onChange={handleImageChange}
                        />
                        {
                          fileSizeError ? (
                            <>
                              <div className="validationError">
                                <div className="text-danger">Error: File size exceeds the 5MB limit. Please upload a smaller file.</div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div><p><small>Please upload a file that is 5MB or smaller.</small></p></div>
                            </>
                          )
                        }
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <TextArea
                        id="description"
                        name="description"
                        value={values?.description}
                        rows="3"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        labelText="Description"
                        customError={errors.description && touched.description}
                        errorMessage={errors.description}
                        erroClass={errors.description && touched.description}
                        requiredStar={true}
                      />

                      {/* <div className="form-group">
                        <extarea
                          onChange={handleInputChangePrevFields}
                          onBlur={handleBlur}
                          customError={values.description && values.description}
                          errorMessage={values.description}
                          erroClass={values.description ? "validationError" : ""}
                          requiredStar={true}
                        >
                        
                        
                      </div> */}
                    </div>
                    <div className="col-md-12">
                      <div className="formActionButtons">
                        <Link
                          to="/consent-capacity"
                          className="btn btn-sm btn-outline-primary"
                        >
                          Back
                        </Link>
                        {isSubmitButtonClicked ? (
                          <Button className="btn-sm" variant="primary" disabled>
                            Loading...
                          </Button>
                        ) : (
                          <Button type="submit" className="btn-sm" variant="primary">
                            Submit
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </Layout>
      <ToastContainer />
    </>
  );
}

export default CCAddNewForm;
